const VariableType = {
	SpreadSheet: 'SpreadSheet',
	ComponentMassFlow: 'ComponentMassFlow',
	ComponentMassFrac: 'ComponentMassFrac',
	Variable: 'Variable'
};

export default VariableType;
